import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import type AiCostLimitView from '@UI/Store/AiCostLimits/Views/AiCostLimitView';

/** Names the subject of a limit ("de la structure ADAR"); the bare form when its label is unknown. */
const describeLimitSubject = (limit: AiCostLimitView, options: AiCostFilterOptionsView | null): string => {
	switch (limit.level) {
		case 'account':
			return 'du compte';
		case 'organization': {
			const label = options?.organizations.find((item) => item.id === limit.subjectId)?.label;

			return label === undefined ? 'de la structure' : `de la structure ${label}`;
		}
		case 'facility': {
			const label = options?.facilities.find((item) => item.id === limit.subjectId)?.label;

			return label === undefined ? "de l'agence" : `de l'agence ${label}`;
		}
		case 'user': {
			const label = options?.users.find((item) => item.id === limit.subjectId)?.label;

			return label === undefined ? "de l'utilisateur" : `de l'utilisateur ${label}`;
		}
	}
};

export default describeLimitSubject;
